import { createFileRoute } from "@tanstack/react-router";
import Page from "@project/admin/pages/donation-setup/donation-masters";

export const Route = createFileRoute("/admin/_donation-setup/donation-masters")(
  {
    component: Page,
  }
);
